// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__zapph","left":"Virtual_left__BiGQD","wrapper":"Virtual_wrapper__lo9NK"};